import React, { useContext, useState } from "react";
import "./emailForm.scss";
import { simplyClick, validateEmail } from "../../helpers";
import ButtonSubmit from "../buttonSubmit";
import InputGlobal from "../inputGlobal";
import {
  errorEventsEmail,
  ERROR_EMAIL_ALREADY_USED,
  landingId,
} from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";
import Tooltip from "../Tooltip";
import LoaderEmail from "../LoaderEmail/index";
import ProgressDots from "../ProgressDots/ProgressDots";
import cn from "classnames";

function EmailForm({ nextStep }) {
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);
  const { data, setData } = useContext(ContextProfileUser);
  const [showTooltip, setShowTooltip] = useState(false);
  const [loaderText, setLoaderText] = useState({
    main: "",
    sub: "",
  });

  const handlerSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    setLoaderText({
      main: "Verifying your email...",
      sub: "This might take a moment.",
    });

    const textTimeout = setTimeout(() => {
      setLoaderText({
        main: "Still verifying your email...",
        sub: "Thanks for your patience!",
      });
    }, 3000);

    validateEmail(data.email, (result) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderText({
        main: "",
        sub: "",
      });
      const { status, error } = result;
      setLoader(false);
      if (!status && error) {
        const analyticsEvent = errorEventsEmail[error];
        if (analyticsEvent) {
          simplyClick(analyticsEvent);
        }
        setErrorEmail(error);
        return;
      }
      nextStep();
    });
  };

  const handleAddEmail = ({ target: { value } }) => {
    setEmailValue(value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setData({ ...data, email: value });
  };

  return (
    <>
      {loader && (
        <LoaderEmail textMain={loaderText.main} textSub={loaderText.sub} />
      )}
      <div className="email__form-wrapper">
        <div className="user__form-top">
          <h3>My email</h3>
        </div>
        <form
          className="form__email"
          onSubmit={handlerSubmit}
          autoComplete="on"
          noValidate={true}
        >
          <div className="input__wrapper">
            <InputGlobal
              onChange={(e) => handleAddEmail(e)}
              placeholder={"Enter your real email address"}
              className={cn("input__global", "input__email", {
                input__error: errorEmail,
              })}
              name={"email"}
              type={"email"}
              value={data.email || ""}
              autoComplete="email"
              onFocus={() => {
                if (!data.email || data.email.trim() === "") {
                  setShowTooltip(true);
                } else {
                  setShowTooltip(false);
                }
                simplyClick("cl_lnd_email_type_email");
              }}
              onBlur={() => setShowTooltip(false)}
            />
            <Tooltip
              text="We'll use this email for account verification and important notifications."
              showTooltip={showTooltip}
              className="email"
            />
          </div>

          {errorEmail && (
            <p className="errorEmail">
              {errorEmail === ERROR_EMAIL_ALREADY_USED
                ? "This email is already registered"
                : errorEmail}
            </p>
          )}
          {errorEmail === ERROR_EMAIL_ALREADY_USED && (
            <div className="extra-info">
              <p>
                <a
                  href={`/login/?landing_id=${landingId}${data?.email
                    ? `&email=${encodeURIComponent(data.email)}`
                    : ""
                    }`}
                  id="login-link"
                  onClick={() => simplyClick("cl_lnd_againemail_login")}
                >
                  Log in
                </a>{" "}
                or use another email
              </p>
            </div>
          )}

          <ButtonSubmit
            className={"button__global button__email"}
            text={"NEXT"}
          />
          <ProgressDots total={6} activeCount={5} />
        </form>
      </div>
    </>
  );
}

export default EmailForm;
